<template>
  <div>
    <table id="users-grid" class="b2b-grid b2b-grid--collapse mb-0">
      <thead class="b2b-grid__header">
        <tr>
          <th
            v-for="(column, index) in columns"
            :key="index"
            class="b2b-grid__cell b2b-grid__head"
            :class="[column.cssClasses]"
            v-html="column.label"
          ></th>
        </tr>
      </thead>

      <tbody>
        <template v-for="(row, rowIndex) in paginatedData">
          <user-item :key="row[idKey] + rowIndex" :row="row" :row-id="row[idKey]" />
        </template>
      </tbody>
    </table>
    <div class="mt-2">
      <pagination
        v-if="pageCount > 1"
        ref="pagination"
        :page-number="pageNumber"
        :page-count="pageCount"
        @page-change="pageChange"
        @prev-page="prevPage"
        @next-page="nextPage"
      ></pagination>
    </div>
  </div>
</template>

<script>
import pagination from '../../../mixins/pagination';

export default {
  mixins: [pagination],

  props: {
    size: {
      type: Number,
      required: false,
      default: ACC.usersPageSize || 15,
    },

    gridData: {
      type: Array,
      default: () => [],
    },

    columns: {
      type: Array,
      default: () => [],
    },

    idKey: {
      type: String,
      default: 'uid',
    },
  },

  data() {
    return {};
  },

  computed: {
    listData() {
      return this.gridData;
    },
  },

  provide() {
    return {
      grid: this,
    };
  },
};
</script>
